module.exports = __webpack_public_path__ + "static/media/Slider2.c68f712f.png";